import {Box, Card, CardActionArea, Stack, Typography} from "@mui/material";
import {ViewModelProps} from "../../../config/type";
import {MaterialSymbol} from "react-material-symbols";
import {
  BORDER_RADIUS_OUTER,
  dropShadowEl1Theme,
  fontFamilySecondaryTheme,
} from "../../../config/themes/theme";

export type CategoryItemUIType = {
  id: any;
  isSelected: boolean;
  viewModel: ViewModelProps;
};
interface CategoryItemUIProps extends CategoryItemUIType {
  onClick: (id: any) => void;
}
export default function CategoryItemV3UI({
  isSelected,
  viewModel,
  onClick,
}: CategoryItemUIProps) {
  return (
    <Box sx={{position: "relative"}}>
      <Card
        sx={{
          borderRadius: BORDER_RADIUS_OUTER,
          border: isSelected ? "2px solid" : "none",
          borderColor: isSelected ? "primary.dark" : "#DDDDDD",
          bgcolor: isSelected ? "primary.main" : "white",
          width: "200px",
          height: "90px",
          boxShadow: dropShadowEl1Theme,
        }}>
        <CardActionArea
          data-active={isSelected ? "" : undefined}
          onClick={() => {
            if (isSelected) return;
            onClick(viewModel.id);
          }}
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            pt: "14px",
            pl: "14px",
            "&[data-active]": {
              bgcolor: "primary.main",
            },
            display: "flex",
            direction: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}>
          <Stack
            width={"100%"}
            alignItems={"left"}
            gap={0}
            textAlign={"left"}
            zIndex={2}
            fontFamily={fontFamilySecondaryTheme}>
            <Typography
              fontSize={"1rem"}
              fontWeight={900}
              textTransform={"uppercase"}>
              {viewModel.name}
            </Typography>
            <Typography
              mt={"-4px"}
              fontSize={"0.75rem"}
              fontWeight={800}
              letterSpacing={"2%"}
              textTransform={"uppercase"}
              color="primary.dark">
              {viewModel.description}
            </Typography>
          </Stack>
          <Box
            height={"100%"}
            width={"100%"}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
              backgroundImage: `url(${viewModel.image})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPositionX: "right",
              backgroundPositionY: "bottom",
              backgroundBlendMode: "multiply",
              transform: "scale(1) translateY(10px)",
            }}
          />
        </CardActionArea>
      </Card>
      {isSelected && (
        <Box
          sx={{
            zIndex: 3,
            width: "24px",
            height: "24px",
            position: "absolute",
            borderRadius: "50%",
            bgcolor: "primary.dark",
            color: "white",
            top: "-5px",
            right: "-7px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <MaterialSymbol icon="check_small" size={24} />
        </Box>
      )}
    </Box>
  );
}
